<lx-online-courses-wayfinder-banner></lx-online-courses-wayfinder-banner>
<p-card styleClass="quote-tool-lite__course-tabs__card">
  <p-tabView
    class="course-step__tab-view"
    [class.course-step__tab-view--overflow-style]="tabs.length > 2"
    [class.course-step__tab-view--small-items]="tabs.length === 4"
    [ngClass]="'course-step__tab-view--' + activeFlow"
    (activeIndexChange)="setActiveFlow($event)"
    (onChange)="trackClickEvent()"
    [activeIndex]="activeIndex"
    styleClass="quote-tool-lite__course-tabs__tab-view"
    data-qa="ageGroup_panel"
    lxDragScroll="p-tabview-nav"
  >
    <p-tabPanel *ngFor="let tab of tabs">
      <ng-template pTemplate="header">
        <div tabindex="0" (keydown.enter)="setActiveFlow(activeIndex)">
          <ng-container *ngTemplateOutlet="tab.header"></ng-container>
        </div>
      </ng-template>

      <ng-container *ngTemplateOutlet="tab.body"></ng-container>
    </p-tabPanel>
  </p-tabView>
</p-card>

<ng-template #adultsHeaderTab>
  <div class="course-step__course-tabs">
    <div
      class="course-step__course-tabs__icon course-step__course-tabs__icon--adult"
      [class.course-step__course-tabs__icon--inactive]="activeFlow !== 'adult'"
    ></div>
    <div
      class="course-step__course-tabs__text"
      [class.course-step__course-tabs__text--adult]="activeFlow === 'adult'"
      [class.course-step__course-tabs__text--inactive]="activeFlow !== 'adult'"
      i18n
    >
      Language schools (+16)
    </div>
  </div>
</ng-template>
<ng-template #adultsTab>
  <lx-language-schools
    *ngIf="activeFlow === 'adult'"
    (validCoursePayload)="updateValidity($event)"
    (coursePayload)="saveCoursePayload($event)"
  ></lx-language-schools>
</ng-template>

<ng-template #juniorsHeaderTab>
  <div class="course-step__course-tabs">
    <div
      class="course-step__course-tabs__icon course-step__course-tabs__icon--junior"
      [class.course-step__course-tabs__icon--inactive]="activeFlow !== 'junior'"
    ></div>
    <div
      class="course-step__course-tabs__text"
      [class.course-step__course-tabs__text--junior]="activeFlow === 'junior'"
      [class.course-step__course-tabs__text--inactive]="activeFlow !== 'junior'"
      i18n
    >
      Language camps (8-17)
    </div>
  </div>
</ng-template>
<ng-template #juniorsTab>
  <lx-language-camps
    *ngIf="activeFlow === 'junior'"
    (validCoursePayload)="updateValidity($event)"
    (coursePayload)="saveCoursePayload($event)"
  ></lx-language-camps>
</ng-template>

<ng-template #ayaHeaderTab>
  <div class="course-step__course-tabs">
    <div
      class="course-step__course-tabs__icon course-step__course-tabs__icon--aya"
      [class.course-step__course-tabs__icon--inactive]="activeFlow !== 'aya'"
    ></div>
    <div
      class="course-step__course-tabs__text"
      [class.course-step__course-tabs__text--aya]="activeFlow === 'aya'"
      [class.course-step__course-tabs__text--inactive]="activeFlow !== 'aya'"
      i18n
    >
      Academic Year Abroad
    </div>
  </div>
</ng-template>
<ng-template #ayaTab>
  <lx-academic-year-abroad
    *ngIf="activeFlow === 'aya'"
    (validCoursePayload)="updateValidity($event)"
    (coursePayload)="saveCoursePayload($event)"
  ></lx-academic-year-abroad>
</ng-template>

<ng-template #onlinedHeaderTab>
  <div class="course-step__course-tabs">
    <div
      class="course-step__course-tabs__icon course-step__course-tabs__icon--online"
      [class.course-step__course-tabs__icon--inactive]="activeFlow !== 'online'"
    ></div>
    <div
      class="course-step__course-tabs__text"
      [class.course-step__course-tabs__text--online]="activeFlow === 'online'"
      [class.course-step__course-tabs__text--inactive]="activeFlow !== 'online'"
      i18n
    >
      Online English Courses
    </div>
  </div>
</ng-template>
<ng-template #onlineTab>
  <lx-online-courses *ngIf="activeFlow === 'online'" (validCoursePayload)="updateValidity($event)" (coursePayload)="saveCoursePayload($event)">
  </lx-online-courses>
</ng-template>
